<mat-card class="support-card">
	<mat-card-header class="p-05">
		<div class="header-content">
			<div class="icon-container">
				<lucide-angular name="shield" class="custom-icon"></lucide-angular>
			</div>
			<mat-card-title>
				<app-title title="Soporte Técnico" headerType="3"></app-title>
				<mat-card-subtitle class="mt-05"
					>¿Necesitas ayuda? Estamos aquí para asistirte</mat-card-subtitle
				>
			</mat-card-title>
		</div>
	</mat-card-header>

	<mat-card-content class="card-content mt-1 mat-typography">
		<div class="contact-item">
			<div class="icon-container">
				<lucide-angular name="phone" class="custom-icon"></lucide-angular>
			</div>
			<div class="contact-info">
				<app-title title="0800-999-3476" headerType="4"></app-title>
				<div class="contact-secondary mt-05">Interno: 0</div>
			</div>
		</div>

		<div class="contact-item">
			<div class="icon-container">
				<lucide-angular name="mail" class="custom-icon"></lucide-angular>
			</div>
			<div class="contact-info">
				<a href="mailto:visec-mrv&#64;bcr.com.ar">
					<app-title
						title="visec-mrv&#64;bcr.com.ar"
						headerType="4"
					></app-title>
				</a>
				<div class="contact-secondary mt-05">Respuesta en 24hs</div>
			</div>
		</div>

		<div class="contact-item">
			<div class="icon-container">
				<lucide-angular
					name="message-circle-more"
					class="custom-icon"
				></lucide-angular>
			</div>
			<div class="contact-info">
				<a
					href="https://api.whatsapp.com/send?phone={{ supportPhoneNumber }}"
					target="_blank"
				>
					<app-title
						title="{{ formattedSupportPhoneNumber }}"
						headerType="4"
					></app-title>
				</a>
				<div class="contact-secondary mt-05">WhatsApp Chat</div>
			</div>
		</div>
	</mat-card-content>
</mat-card>
